import { Box } from "@mui/material";
import { palette } from "../../styles/theme";
import SpecsModeSelectorSidebar from "./SpecsModeSelectorSidebar";
import SpecsSidebarLayerEditor from "./SpecsSidebarLayerEditor";
import { useSpecsEditorContextValue } from "./useSpecsEditor";

export default function SpecsEditorRightSidebar() {
  const { selectedPanelKind } = useSpecsEditorContextValue();

  const showScopedSidebar =
    selectedPanelKind === "layer" || selectedPanelKind === "positions";
  const showLayerSidebar = selectedPanelKind === "layer";

  return (
    <Box
      sx={{
        width: 260,
        minWidth: 260,
        maxHeight: "100vh",
        overflowY: "auto",
        borderLeft: `1px solid ${palette.grey.lightGrey}`,
        bgcolor: palette.grey.lightBackground,
        p: 1.5,
        pb: 8,
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
      }}
    >
      <SpecsModeSelectorSidebar />

      {showScopedSidebar ? (
        showLayerSidebar ? (
          <SpecsSidebarLayerEditor />
        ) : null
      ) : null}
    </Box>
  );
}
